import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'flags',
  template: `
    <div [class]="flagName | flag: type" id="ngx-ef-flags"></div>
  `,
})
export class NgxEfFlagsComponent implements OnInit {

  @Input() public flagName: any;
  @Input() public type: any;
  constructor() { }

  ngOnInit(): void {
  }

}
